@if (!(hideHeader$ | async)) {
  @let avatarUrl = authService.avatar$ | async;
  @let availability = presenceService.availability$ | async;
  @let profileData = authService.profile$ | async;
  <div class="header">
    <mat-card>
      <mat-card-header>
        <div mat-card-avatar>
          <div class="avatar">
            @if (!avatarUrl) {
              <img mat-card-avatar src="./assets/images/AvatarPlaceholder.svg" class="avatar-image" alt="" />
            }
            @if (avatarUrl) {
              <img mat-card-avatar [src]="avatarUrl" class="avatar-image" alt="" />
            }
            @if (availability) {
              <div class="presence" [ngClass]="availability | lowercase"></div>
            }
            @if (!availability) {
              <div class="presence none"></div>
            }
            <nimbus-tooltip [text]="presenceMap[availability] | translate" [position]="'bottom'"></nimbus-tooltip>
          </div>
        </div>
        <mat-card-title>
          <span class="text-no-wrap tooltip-container assistant-title" disabled>
            {{ profileData?.displayName }}
            <nimbus-tooltip [text]="profileData?.displayName" [position]="'bottom'"></nimbus-tooltip>
          </span>
        </mat-card-title>
        @if (authService.authenticated$ | async) {
          <mat-card-subtitle class="responsibility-profile">
            @if (profileService.profile$ | async) {
              <mat-select
                #matSelect
                [(ngModel)]="profile"
                [disabled]="profileChangeDisabled$ | async"
                class="mat-select-panel responsibility-profile"
                (click)="selectClick()"
                [disableOptionCentering]="true"
              >
                @if (profileService.responsibilityProfiles$ | async; as profiles) {
                  @for (item of profiles; track item.id) {
                    <mat-option [value]="item.id" class="responsibility-profile-option">
                      {{ item.name }}
                      <nimbus-tooltip [text]="item.name"></nimbus-tooltip>
                    </mat-option>
                  }
                }
              </mat-select>
            }
          </mat-card-subtitle>
        }
        <div class="header-buttons-container">
          @if (displayOutboundIcon) {
            <span class="tooltip-container">
              <button
                primaryiconbutton
                class="nimbus-material-icon-button primary call-as-button"
                [routerLink]="['/outbound']"
                [disabled]="disableOutboundIcon"
              >
                <i class="button-icon" [nimbusIcon]="ICONS.PHONE"></i>
              </button>
              @if (disableOutboundIcon) {
                <nimbus-tooltip [text]="TranslationKeys.CallAsNotEligible | translate"></nimbus-tooltip>
              }
            </span>
          }
          <button class="menu-button" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <i class="button-icon" [nimbusIcon]="ICONS.MENU"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/settings']">
              <i class="button-icon" [nimbusIcon]="ICONS.COG_LIGHT"></i>
              <span>{{ TranslationKeys.MenuSettings | translate }}</span>
            </button>
            <button mat-menu-item (click)="openNimbus()">
              <i class="button-icon" [nimbusIcon]="ICONS.GLOBE_LIGHT"></i>
              <span>{{ TranslationKeys.MenuOpenInNimbus | translate }}</span>
            </button>
            @if (openLogFolderEnabled) {
              <button mat-menu-item (click)="openLogFolder()">
                <i class="button-icon" [nimbusIcon]="ICONS.FOLDER_LIGHT"></i>
                <span>{{ TranslationKeys.AssistantOpenLogFolder | translate }}</span>
              </button>
            }
            <button mat-menu-item [routerLink]="['/info']">
              <i class="button-icon" [nimbusIcon]="ICONS.INFO_CIRCLE_LIGHT"></i>
              <span>{{ TranslationKeys.MenuInfo | translate }}</span>
            </button>
            <div class="separator"></div>
            <button mat-menu-item (click)="authService.logoutPopup()" [disabled]="!(authService.authenticated$ | async)">
              <i class="button-icon" [nimbusIcon]="ICONS.USER_LIGHT"></i>
              {{ TranslationKeys.GeneralLogout | translate }}
            </button>
            <button mat-menu-item (click)="quit()">
              <i class="button-icon" [nimbusIcon]="ICONS.LOGOUT"></i>
              {{ TranslationKeys.MenuQuit | translate }}
            </button>
          </mat-menu>
        </div>
        <div class="separator"></div>
      </mat-card-header>
    </mat-card>
    <div class="separator"></div>
  </div>
}
@if (isInfo$ | async) {
  <div class="header">
    <mat-card>
      <mat-card-header class="info-header">
        <mat-card-title>
          <button mat-menu-item (click)="back()">
            <i class="button-icon" [nimbusIcon]="ICONS.CHEVRON_LEFT"></i>
            <span>{{ TranslationKeys.GeneralBack | translate }} </span>
          </button>
        </mat-card-title>
        <div class="separator"></div>
      </mat-card-header>
    </mat-card>
  </div>
}
